<template lang="pug">
  y-dialog(v-model="showModal" fill-height fluid scrollable persistent :fullscreen="$vuetify.breakpoint.xsOnly" transition="fade-transition" max-width="600px")
    v-card
      v-card-title.pa-0
        v-row.px-5.pt-3.pb-2(v-if="hasChanges" no-gutters align="center" :style="`background-color: ${$vuetify.theme.themes[$theme].success600}`")
          v-col.shrink
            v-btn.ml-n3(text icon @click="showModal = !showModal" height)
              eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].basic100" width="24" height="24")
          v-col.ml-3
            p.mb-0.h6.basic100--text {{ $t('save_changes') }}
          v-col.ml-3.shrink
            v-layout
              v-btn.mr-2.my-auto(depressed small outlined color="basic100" @click="clickRevert()")
                .button-AA-small.basic100--text {{ $t('cancel') }}
              v-btn.my-auto.basic100(depressed small @click="clickSave()" :loading="isLoading")
                .button-AA-small.primary500--text {{ $t('save') }}
        v-row.px-5.pt-3.pb-2(v-else no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="showModal = !showModal" height)
              eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].primary" width="24" height="24")
          v-col.ml-3
            p.mb-0.h6.basic800--text {{ $t('seo_favicon') }}

      v-card-text.pa-0
        v-container.pa-5
          div.h5.primary--text {{ $t('search_engine_optimization') }}


</template>

<script>
import LandingFormType from '@/components/landingform/LandingFormType.vue'

export default {
  name: 'EditLandingMetaData',
  props: ['open', 'parentForm'],
  components: { LandingFormType },
  data: () => ({
    isLoading: false,
    form: {},
    original: {}
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    hasChanges () {
      if (JSON.stringify(this.original) === JSON.stringify(this.form)) {
        return false
      }
      return true
    }
  },
  mounted () {
    this.form = JSON.parse(JSON.stringify(this.parentForm))
    this.original = JSON.parse(JSON.stringify(this.parentForm))
  },
  methods: {
    clickRevert () {
      this.form = JSON.parse(JSON.stringify(this.original))
    },
    clickSave () {
      this.isLoading = true
      let data = {
        type: this.form.type
      }
      this.$axios.patch(`/forms/${this.parentForm.id}`, data)
        .then(resp => {
          this.$emit('update:parentForm', resp.data)
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "seo_favicon": "SEO & favicon",
    "search_engine_optimization": "Search Engine Optimization (SEO)"
  },
  "id": {
    "seo_favicon": "SEO & favicon",
    "search_engine_optimization": "Search Engine Optimization (SEO)"
  }
}
</i18n>